import { default as DragPan } from 'ol/interaction/DragPan';
import { default as RBaseInteraction } from './RBaseInteraction';
/** Panning by dragging */
class RDragPan extends RBaseInteraction {
    createOL(props) {
        this.classProps = RDragPan.classProps;
        return new DragPan(Object.keys(props)
            .filter((p) => this.classProps.includes(p))
            .reduce((ac, p) => (Object.assign(Object.assign({}, ac), { [p]: props[p] })), {}));
    }
}
RDragPan.classProps = ['condition', 'kinetic'];
export default RDragPan;
//# sourceMappingURL=RDragPan.js.map